import React from "react";
import { TextField, Box, Typography } from "@mui/material";
import RequiredMark from "./RequiredMark";
 
export const fieldShellSx = (theme) => ({
  "& .MuiOutlinedInput-root": {
    borderRadius: "6px",
    height: "auto",
    fontSize: "14px",
    backgroundColor: "#FFFFFF",
    "& fieldset": {
      borderColor: "#B5BBC1",
      borderWidth: "1px",
    },
    "&:hover fieldset": {
      borderColor: "#D6D9DB",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#11783C",
      borderWidth: "1px",
    },
    "&.Mui-disabled": {
      backgroundColor: "#F5F5F5",
      "& fieldset": {
        borderColor: "#D6D9DB",
      },
    },
  },
  "& .MuiInputBase-input": {
    padding: "10px 12px",
    "&::placeholder": {
      color: "#8F969D",
      opacity: 1,
    },
    // "&::placeholder": {
    //   color: "#292C2F",
    //   opacity: 1,
    // },
    "&.Mui-disabled": {
      color: "#9FA3A8",
      WebkitTextFillColor: "#9FA3A8",
    },
  },
  "& .MuiInputBase-inputMultiline": {
    padding: "0px !important",
    lineHeight: 1.5,
  },
});
 
const FormTextField = ({
  label,
  required = false,
  field,
  form,
  touched,
  errors,
  handleChange,
  handleBlur,
  theme,
  value,
  onChange,
  error,
  errorMessage,
  disabled = false,
  maxwidth,
  placeHolder,
  transparent = false,
  ...props
}) => {
  const fieldValue = value !== undefined ? value : (form?.[field] || "");
  const isError = error !== undefined ? error : (touched?.[field] && !!errors?.[field]);
  const fieldError = errorMessage || errors?.[field];
  
  const handleFieldChange = onChange || (handleChange ? handleChange(field) : undefined);
  const handleFieldBlur = handleBlur ? handleBlur(field) : undefined;

  return (
    <Box>
      {label && (
        <Typography
          variant="body2"
          sx={{
            mb: 1,
            fontWeight: 400,
            fontSize: "14px",
            color: "#292C2F",
          }}
        >
          {label} {required && <RequiredMark />}
        </Typography>
      )}
      <TextField
        fullWidth
        size="small"
        disabled={disabled}
        value={fieldValue}
        onChange={handleFieldChange}
        onBlur={handleFieldBlur}
        error={isError && !disabled}
        InputLabelProps={{ shrink: false }}
        placeholder={placeHolder}
        sx={{
          ...fieldShellSx(theme),
          width: maxwidth,
          backgroundColor: transparent ? 'transparent' : undefined,
          "& .MuiOutlinedInput-root": {
            ...fieldShellSx(theme)["& .MuiOutlinedInput-root"],
            backgroundColor: transparent ? 'transparent' : undefined,
            "& fieldset": {
              borderColor:
                isError && !disabled ? "#D14343" : "#E3E7EC",
            },
          },
        }}
        {...props}
      />
      {isError && fieldError && (
        <Typography
          sx={{
            color: "#D14343",
            fontSize: "11px",
            mt: 1,
            lineHeight: 1,
          }}
        >
          {fieldError}
        </Typography>
      )}
    </Box>
  );
};
 
export default FormTextField;